import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SimilarHtsSuggestionModel } from '@app/data-layer/models/common';
import { FavoriteHtsNumberModel } from '@app/data-layer/models/common/favorite-hts-number.model';
import { HtsAssistantHelper } from '@shared/hts-assistant/helpers/hts-assistant.helper';

/**
 * The dropdown under the item description: exact matches from the saved catalog first, then (tagged companies) the
 * similar products the company classified before (#13517); "Search all saved catalog HTS codes" stays pinned below.
 */
@Component({
  selector: 'app-bina-catalog-fast-search-list',
  templateUrl: './bina-catalog-fast-search-list.component.html',
  styleUrls: ['./bina-catalog-fast-search-list.component.scss'],
})
export class BinaCatalogFastSearchListComponent implements OnInit, OnChanges {
  @Input() resultItems: FavoriteHtsNumberModel[];
  @Input() public suggestions: SimilarHtsSuggestionModel[] = [];
  @Input() public isShowCatalogLink: boolean = false;
  @Output() public htsInsert: EventEmitter<FavoriteHtsNumberModel> = new EventEmitter<FavoriteHtsNumberModel>();
  @Output() public suggestionInsert: EventEmitter<SimilarHtsSuggestionModel> = new EventEmitter<SimilarHtsSuggestionModel>();
  @Output() public findInCatalog: EventEmitter<void> = new EventEmitter<void>();
  @Output() public clear: EventEmitter<void> = new EventEmitter<void>();

  /** The suggestions without the codes the catalog items above already show (#13533); inputs are replaced, never mutated. */
  public visibleSuggestions: SimilarHtsSuggestionModel[] = [];

  private isElementClicked = false;

  constructor() {}

  ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.resultItems || changes.suggestions) {
      this.visibleSuggestions = HtsAssistantHelper.withoutCatalogCodes(this.suggestions, this.resultItems);
    }
  }

  public onHtsInsert(selectsFavoriteHts: FavoriteHtsNumberModel) {
    this.htsInsert.emit(selectsFavoriteHts);
  }

  public onSuggestionInsert(suggestion: SimilarHtsSuggestionModel): void {
    this.suggestionInsert.emit(suggestion);
  }

  /** Opens the catalog sidebar; the dropdown goes away like after a pick. */
  public onFindInCatalog(): void {
    this.findInCatalog.emit();
    this.clear.emit();
  }

  public onClear() {
    this.clear.emit();
  }

  public get isShowSuggestions(): boolean {
    return this.visibleSuggestions.length > 0;
  }

  public trackBySuggestion(index: number, suggestion: SimilarHtsSuggestionModel): string {
    return `${suggestion.htsNumber}-${suggestion.source}`;
  }

  @HostListener('click')
  clickedInsideElement() {
    this.isElementClicked = true;
  }

  @HostListener('document:click')
  clickedOutsideElement() {
    if (!this.isElementClicked) {
      this.onClear();
    }
    this.isElementClicked = false;
  }
}
